import client from '../client';
import type { ApiResponse } from '../../types/api';
import type { WalletOverview, WalletTransaction, WithdrawInput } from '../../types/wallet';

export const walletApi = {
  getOverview: async (storeId: string): Promise<WalletOverview> => {
    const res = await client.get<ApiResponse<WalletOverview>>(`/dashboard/${storeId}/wallet`);
    return res.data.data!;
  },

  getTransactions: async (storeId: string): Promise<WalletTransaction[]> => {
    const res = await client.get<ApiResponse<{ transactions: WalletTransaction[] }>>(
      `/dashboard/${storeId}/wallet/transactions`,
    );
    return res.data.data?.transactions ?? [];
  },

  withdraw: async (storeId: string, data: WithdrawInput): Promise<void> => {
    await client.post(`/dashboard/${storeId}/wallet/withdraw`, data);
  },

  getEarnings: async (storeId: string, period: 'months' | 'years' = 'months') => {
    const res = await client.get<ApiResponse<{
      earnings: Array<{ date: string; revenue: number; orders: number; customers: number }>;
      period: string;
      currency: string;
    }>>(`/dashboard/${storeId}/wallet/earnings`, { params: { period } });
    return res.data.data!;
  },
};
